import type { CriterionLocaleBundle } from '../localize'

/** Unofficial translations from docs/kata — English scoring text remains authoritative. */
export const juNoKataCriteriaI18n: CriterionLocaleBundle = {
  "ja": {
    "ju-gen-dist-tsuki-dashi": {
      "text": "技"
    },
    "ju-gen-dist-kata-oshi": {
      "text": "突出（Tsuki-dashi）"
    },
    "ju-gen-dist-ryote-dori": {
      "text": "肩押（Kata-oshi）"
    },
    "ju-gen-dist-kata-mawashi": {
      "text": "両手取（Ryote-dori）"
    },
    "ju-gen-dist-ago-oshi": {
      "text": "肩廻（Kata-mawashi）"
    },
    "ju-gen-dist-kiri-oroshi": {
      "text": "腮押（Ago-oshi）"
    },
    "ju-gen-dist-ryokata-oshi": {
      "text": "切下（Kiri-oroshi）"
    },
    "ju-gen-dist-naname-uchi": {
      "text": "両肩押（Ryo-kata-oshi）"
    },
    "ju-gen-dist-katate-dori": {
      "text": "斜打（Naname-uchi）"
    },
    "ju-gen-dist-katate-age": {
      "text": "片手取（Katate-dori）"
    },
    "ju-gen-dist-obi-tori": {
      "text": "片手挙（Katate-age）"
    },
    "ju-gen-dist-mune-oshi": {
      "text": "帯取（Obi-tori）"
    },
    "ju-gen-dist-tsuki-age": {
      "text": "胸押（Mune-oshi）"
    },
    "ju-gen-dist-uchi-oroshi": {
      "text": "突上（Tsuki-age）"
    },
    "ju-gen-dist-ryogan-tsuki": {
      "text": "打下（Uchi-oroshi）"
    },
    "ju-gen-submitting": {
      "text": "両眼突（Ryogan-tsuki）",
      "hint": "約一歩、やや広く"
    },
    "ju-tsuki-dashi-1": {
      "text": "受は継ぎ足（tsugi-ashi）で進み、腕を帯、喉の高さへ徐々に連続して上げ、三歩目で取の烏兎（uto、眉間）を攻撃する。"
    },
    "ju-tsuki-dashi-2": {
      "text": "受は三歩目で取の眉間を攻撃する。取は受の右手首を親指を下にして、左手首を親指を上にして取る。"
    },
    "ju-tsuki-dashi-3": {
      "text": "取と受の解き方：回転時の両脚の開閉、および親指を上にした握り方。"
    },
    "ju-tsuki-dashi-4": {
      "text": "終末：受の右腕を伸ばし、後方へ崩す。"
    },
    "ju-kata-oshi-1": {
      "text": "受は右手を上げ、取の右肩の後ろを押す。"
    },
    "ju-kata-oshi-2": {
      "text": "取は身をかがめる。受も取の潜り込みに従ってかがみ、右の手のひらで取の肩を後方へ押す。取は右手で受の右手の四指を握って後退する。"
    },
    "ju-kata-oshi-3": {
      "text": "受は攻撃前に左手を準備する。"
    },
    "ju-kata-oshi-4": {
      "text": "受は左足を進め、左手の指先で取の眉間を攻撃する。取はまず受の左手の指、次に右手の指を握り、後退しながら両手を伸ばして反撃する。"
    },
    "ju-kata-oshi-5": {
      "text": "終末：取は受の両腕を伸ばし、後方へ崩す。"
    },
    "ju-ryote-dori-1": {
      "text": "受は取の両手首を握る。"
    },
    "ju-ryote-dori-2": {
      "text": "取は両手を後ろへ引き、左足を少し引いて受を前方へ崩し、外巻込（Soto-makikomi）を施す。"
    },
    "ju-ryote-dori-3": {
      "text": "取は受を体に乗せて持ち上げる。受は両脚を伸ばす。"
    },
    "ju-kata-mawashi-1": {
      "text": "受は右手を取の右肩の後ろに、左手を取の左肩の前に置き、取の両肩を回す。"
    },
    "ju-kata-mawashi-2": {
      "text": "取は左手で受を前方へ崩し、一本背負投（Ippon-seoi-nage）で肩に乗せる。"
    },
    "ju-kata-mawashi-3": {
      "text": "取は受を体に乗せて持ち上げる。受は両脚を伸ばす。"
    },
    "ju-ago-oshi-1": {
      "text": "取は三歩前進し、三歩目で右に向く。"
    },
    "ju-ago-oshi-2": {
      "text": "受は継ぎ足で進み、腕を帯、喉の高さへ徐々に連続して上げ、三歩目で右手の指先により取の顎の右側を押そうとする。"
    },
    "ju-ago-oshi-3": {
      "text": "取の防御：左足、体、顔を左へ向け、右手で受の右手を握り、右親指を受の右の手のひらに当て、右足を踏み出して 180° 回る。"
    },
    "ju-ago-oshi-4": {
      "text": "受は攻撃前に手を準備する。"
    },
    "ju-ago-oshi-5": {
      "text": "受は左足を進め、左手の指先で取の眉間を攻撃する。取は左足を引き、手を握って反撃する。"
    },
    "ju-ago-oshi-6": {
      "text": "終末：取は曲げた腕で制し、受を後方へ崩す。"
    },
    "ju-kiri-oroshi-1": {
      "text": "受の攻撃準備：右足を引いて右に向き、同時に右の手のひらを前に向ける。"
    },
    "ju-kiri-oroshi-2": {
      "text": "受は取に向き直り、右足を踏み出して手刀（Te-gatana）で攻撃する。"
    },
    "ju-kiri-oroshi-3": {
      "text": "取は右足、左足の順に後退し、受の右手首を握り、継ぎ足で二歩前進して受を右後隅へ崩す。"
    },
    "ju-kiri-oroshi-4": {
      "text": "受は取の右肘を押して右手首の握りを外し、大きな円で取を 180° 回す。"
    },
    "ju-kiri-oroshi-5": {
      "text": "取は左足を軸に回り、左手で受の左手を下から握り、左親指を受の左の手のひらに当てる。"
    },
    "ju-kiri-oroshi-6": {
      "text": "取はさらに受の後方へ進み、後方へ崩す。"
    },
    "ju-kiri-oroshi-7": {
      "text": "終末：取は受の左腕を伸ばして後方へ崩す。"
    },
    "ju-ryokata-oshi-1": {
      "text": "受は後ろから両手のひらで取の両肩を下へ押して攻撃する。"
    },
    "ju-ryokata-oshi-2": {
      "text": "取の防御：体を沈め、左足を半歩引き、右足を左へ半歩動かし、回って左手で受の右手首を握る。左足を半歩引き、受は半歩前進する。右足を左へ半歩動かし、右手で受の右手首を握る。"
    },
    "ju-ryokata-oshi-3": {
      "text": "取は回り、受の右手首の握りを変え、前進しながらゆっくり体を起こして受を背中へ引き上げる。"
    },
    "ju-ryokata-oshi-4": {
      "text": "受は左手で取の背中を押して防ぐ。"
    },
    "ju-ryokata-oshi-5": {
      "text": "取は左へ回り、右足、左足の順に後退する。受の踵が畳につく。取は左上腕を受の胸に横に当て、後方へ押す。"
    },
    "ju-ryokata-oshi-6": {
      "text": "終末：取は左上腕で押し、受の右腕を上げて伸ばし、均衡を崩す。"
    },
    "ju-naname-uchi-1": {
      "text": "受は手刀で取の眉間を斜めに打とうとする。"
    },
    "ju-naname-uchi-2": {
      "text": "取はかわして受の手首を握り、右手の指で反撃する。手のひらは下に向ける。"
    },
    "ju-naname-uchi-3": {
      "text": "受は取の手首を握り、左へ回って取を前へ引く。取は左足を進め、左手で受の左手首を握って押し、自分の手首を外す。"
    },
    "ju-naname-uchi-4": {
      "text": "受は取の肘に手を当て、取を回す。"
    },
    "ju-naname-uchi-5": {
      "text": "取は回転し、上体を後ろへ傾けて裏投（Ura-nage）で受を持ち上げる。受は両脚をそろえ、両腕を頭上に伸ばす。"
    },
    "ju-katate-dori-1": {
      "text": "受は取の右手首を握る。"
    },
    "ju-katate-dori-2": {
      "text": "取は右足を斜め前に進め、腕を伸ばして上げる。関節技（Kansetsu-waza）を用いる。"
    },
    "ju-katate-dori-3": {
      "text": "受は右足を前へ進めて防ぎ、右の手のひらで取の右肘を押しのけ、左手を離して取の左肩を引く。"
    },
    "ju-katate-dori-4": {
      "text": "取は回り、浮腰（Uki-goshi）から大腰（O-Goshi）へ移って受を持ち上げる。"
    },
    "ju-katate-age-1": {
      "text": "取と受は右腕と踵を上げてから、互いに近づく。"
    },
    "ju-katate-age-2": {
      "text": "取は衝突を避けて右足を横へ踏み出し、受の左肩と右肘を押さえる。受が反応し、取は受の左肘を制する。受は再び反応する。取は直立して受の反応を制し、動作と反応はゆっくり行い、両者は非常に近い位置にいる。"
    },
    "ju-katate-age-3": {
      "text": "終末：取は受の右腕を伸ばし、後方へ崩す。"
    },
    "ju-obi-tori-1": {
      "text": "受は左足を踏み込み、腕を交差させて左手を上、両手のひらを下にし、取の帯を握ろうとする。"
    },
    "ju-obi-tori-2": {
      "text": "取は右手で受の左手首を握り、手の甲を下にして自分の左へ引く。続いて左手で受の左肘を押し上げ、右手で受の右肩を引き、受の体を右へ回そうとする。"
    },
    "ju-obi-tori-3": {
      "text": "受は回転しながら取の右肘を横へ引き、取の肘を押し上げながら左肩を引く。"
    },
    "ju-obi-tori-4": {
      "text": "取は再び回り、受を腰に引きつけ、浮腰から大腰へ移って持ち上げる。"
    },
    "ju-mune-oshi-1": {
      "text": "受は右の手のひらで取の左胸を押す。取は胸を後ろへ反らし、左手を矢筈（Yahazu、V 字形）にして受の右手首を押し上げ、右手で受の左胸を押す。受は取の右手首を握り、両者は握りを変えながら正面（Shomen）に向かって回る。誤りの分類：小／中（Small/Medium）。"
    },
    "ju-mune-oshi-2": {
      "text": "取は受の右腕を制し、伸ばされた受の左腕の肘のところで握りを変え、受を右後隅へ崩す。誤りの分類：小／中（Small/Medium）。"
    },
    "ju-mune-oshi-3": {
      "text": "終末：取は右足、左足の順に踏み込み、腰を下げて受をさらに崩す。誤りの分類：中（Medium）。"
    },
    "ju-tsuki-age-1": {
      "text": "受は右足を引き、再び前に踏み出して取の顎を突き上げようとする。"
    },
    "ju-tsuki-age-2": {
      "text": "取は後ろへ反って攻撃を避け、右手で拳を受け止め、左の手のひらを受の右肘に当て、左足を進めて受を回す。"
    },
    "ju-tsuki-age-3": {
      "text": "受は左足を軸に 360° 回る。"
    },
    "ju-tsuki-age-4": {
      "text": "取は受の右腕を真上へ引き、左手で受の右肘を握り、腕緘（Ude-garami）の形で受の肩に巻きかけ、右後隅へ崩す。取は左足、右足の順に踏み込む。"
    },
    "ju-uchi-oroshi-1": {
      "text": "受は右拳と右腕を大きく円を描いて上げ、右足を踏み出し、右拳の甲で取の頭頂を打とうとする。"
    },
    "ju-uchi-oroshi-2": {
      "text": "取は右足、左足の順に後退し、右手で受の右手首を上から通常の握りで取り、継ぎ足で二歩前進して右後隅へ崩す。"
    },
    "ju-uchi-oroshi-3": {
      "text": "受は左手を返して指先を下に向け、前方から取の右肘に手のひらを当てて押し、取の体を左へ大きく回す。"
    },
    "ju-uchi-oroshi-4": {
      "text": "取は左足を軸に回り、左手で受の左手首を上から握り、受の後方へ進んで後方へ崩す。"
    },
    "ju-uchi-oroshi-5": {
      "text": "終末：取は受を後方へ崩し、左手で受の左腕に関節技を、右手首で絞技（Shime-waza）を同時に施す。"
    },
    "ju-ryogan-tsuki-1": {
      "text": "受は右手を上げ、指を伸ばして薬指と中指を開き、右足を進めて取の両眼を突く。"
    },
    "ju-ryogan-tsuki-2": {
      "text": "取は左へ回って突きをかわし、左手で受の右手首を握って腕を引く。"
    },
    "ju-ryogan-tsuki-3": {
      "text": "受は左足を進め、左手で取の左手首を握って右腕を外す。"
    },
    "ju-ryogan-tsuki-4": {
      "text": "取は右の手のひらで受の左肘を押し、左腕を外す。"
    },
    "ju-ryogan-tsuki-5": {
      "text": "受は右足を軸に回る。"
    },
    "ju-ryogan-tsuki-6": {
      "text": "取は左足を進め、左手の指を伸ばして薬指と中指を開き、受の両眼を突く。"
    },
    "ju-ryogan-tsuki-7": {
      "text": "受は右へ回って突きをかわし、右手で取の左手首を握って腕を引く。"
    },
    "ju-ryogan-tsuki-8": {
      "text": "取は右足を進め、右手で受の右手首を握って左腕を外す。"
    },
    "ju-ryogan-tsuki-9": {
      "text": "受は左の手のひらで取の右肘を押して右腕を外し、取を回そうとするが、取は受の腰に腕を回し、浮腰から大腰へ移って持ち上げる。"
    }
  },
  "zh-Hant": {
    "ju-gen-dist-tsuki-dashi": {
      "text": "技術"
    },
    "ju-gen-dist-kata-oshi": {
      "text": "Tsuki-dashi"
    },
    "ju-gen-dist-ryote-dori": {
      "text": "Kata-oshi"
    },
    "ju-gen-dist-kata-mawashi": {
      "text": "Ryote-dori"
    },
    "ju-gen-dist-ago-oshi": {
      "text": "Kata-mawashi"
    },
    "ju-gen-dist-kiri-oroshi": {
      "text": "Ago-oshi"
    },
    "ju-gen-dist-ryokata-oshi": {
      "text": "Kiri-oroshi"
    },
    "ju-gen-dist-naname-uchi": {
      "text": "Ryo-kata-oshi"
    },
    "ju-gen-dist-katate-dori": {
      "text": "Naname-uchi"
    },
    "ju-gen-dist-katate-age": {
      "text": "Katate-dori"
    },
    "ju-gen-dist-obi-tori": {
      "text": "Katate-age"
    },
    "ju-gen-dist-mune-oshi": {
      "text": "Obi-tori"
    },
    "ju-gen-dist-tsuki-age": {
      "text": "Mune-oshi"
    },
    "ju-gen-dist-uchi-oroshi": {
      "text": "Tsuki-age"
    },
    "ju-gen-dist-ryogan-tsuki": {
      "text": "Uchi-oroshi"
    },
    "ju-gen-submitting": {
      "text": "Ryogan-tsuki",
      "hint": "約一步，稍寬"
    },
    "ju-tsuki-dashi-1": {
      "text": "受以繼足（tsugi-ashi）前進，手臂逐漸、連續抬起，經腰帶及喉部高度，在第三步攻擊取的眉間（uto）。"
    },
    "ju-tsuki-dashi-2": {
      "text": "受在第三步攻擊取的眉間。取握受的右手腕時拇指朝下，握左手腕時拇指朝上。"
    },
    "ju-tsuki-dashi-3": {
      "text": "取與受的解脫方式：轉身時雙腿的開合，以及拇指朝上的握法。"
    },
    "ju-tsuki-dashi-4": {
      "text": "結束：使受向後失去平衡，受的右臂伸直。"
    },
    "ju-kata-oshi-1": {
      "text": "受抬起右手，推取的右肩後側。"
    },
    "ju-kata-oshi-2": {
      "text": "取俯身；受隨取的下潛而俯身，然後以右掌將取的肩膀向後推；取以右手握住受右手的四指，向後移動。"
    },
    "ju-kata-oshi-3": {
      "text": "受在攻擊前準備好左手。"
    },
    "ju-kata-oshi-4": {
      "text": "受左腳前進，以左手指尖攻擊取的眉間；取先握左手手指，再握右手手指，後退並伸展雙手以反擊。"
    },
    "ju-kata-oshi-5": {
      "text": "結束：取使受雙臂伸直，向後失去平衡。"
    },
    "ju-ryote-dori-1": {
      "text": "受握取的雙手腕。"
    },
    "ju-ryote-dori-2": {
      "text": "取將雙手向後拉，左腳稍退，使受向前失去平衡，施以外卷込（Soto-makikomi）。"
    },
    "ju-ryote-dori-3": {
      "text": "取將受承載於身上並舉起，受雙腿伸直。"
    },
    "ju-kata-mawashi-1": {
      "text": "受轉動取的雙肩：右手置於右肩後側，左手置於左肩前側。"
    },
    "ju-kata-mawashi-2": {
      "text": "取以左手使受向前失去平衡，施以一本背負投（Ippon-seoi-nage），將受承載於肩上。"
    },
    "ju-kata-mawashi-3": {
      "text": "取將受承載於身上並舉起，受雙腿伸直。"
    },
    "ju-ago-oshi-1": {
      "text": "取向前走三步，第三步向右轉。"
    },
    "ju-ago-oshi-2": {
      "text": "受以繼足前進，手臂逐漸、連續抬起，經腰帶及喉部高度，在第三步嘗試以右手指尖推取下巴的右側。"
    },
    "ju-ago-oshi-3": {
      "text": "取的防守：左腳、身體及臉向左轉，以右手握受的右手，右拇指放在受的右掌上，右腳向前踏出並轉身 180°。"
    },
    "ju-ago-oshi-4": {
      "text": "受在攻擊前準備好手。"
    },
    "ju-ago-oshi-5": {
      "text": "受左腳前進，以左手指尖攻擊取的眉間；取左腳後退，以握手方式反擊。"
    },
    "ju-ago-oshi-6": {
      "text": "結束：取以彎曲的手臂控制，使受向後失去平衡。"
    },
    "ju-kiri-oroshi-1": {
      "text": "受準備攻擊：右腳後退並向右轉，同時使右掌朝前。"
    },
    "ju-kiri-oroshi-2": {
      "text": "受轉向取，右腳前進，以手刀（Te-gatana）攻擊。"
    },
    "ju-kiri-oroshi-3": {
      "text": "取先退右腳、再退左腳，握受的右手腕，以繼足前進兩步，使受向右後隅失去平衡。"
    },
    "ju-kiri-oroshi-4": {
      "text": "受推取的右肘，解除右手腕被握的狀態，並以大圓動作使取轉動 180°。"
    },
    "ju-kiri-oroshi-5": {
      "text": "取以左腳為軸轉身，左手由下方握受的左手，左拇指放在受的左掌上。"
    },
    "ju-kiri-oroshi-6": {
      "text": "取繼續移至受的後方，使其向後失去平衡。"
    },
    "ju-kiri-oroshi-7": {
      "text": "結束：取使受左臂伸直，向後失去平衡。"
    },
    "ju-ryokata-oshi-1": {
      "text": "受從後方以雙掌向下壓取的雙肩。"
    },
    "ju-ryokata-oshi-2": {
      "text": "取的防守：沉身，左腳後退半步，右腳向左移半步，轉身，以左手握受的右手腕；左腳再後退半步，受前進半步；右腳向左移半步，以右手握受的右手腕。"
    },
    "ju-ryokata-oshi-3": {
      "text": "取轉身，更換受右手腕的握法，向前移動並緩慢起身，將受拉到背上。"
    },
    "ju-ryokata-oshi-4": {
      "text": "受以左手推取的背部防守。"
    },
    "ju-ryokata-oshi-5": {
      "text": "取向左轉，依右腳、左腳順序後退；受的腳跟落在榻榻米上。取將左上臂橫置於受胸前，向後推。"
    },
    "ju-ryokata-oshi-6": {
      "text": "結束：取以左上臂推壓，同時抬高並伸展受的右臂，使受失去平衡。"
    },
    "ju-naname-uchi-1": {
      "text": "受嘗試以手刀斜擊取的眉間。"
    },
    "ju-naname-uchi-2": {
      "text": "取避開並握受的手腕，然後以右手手指反擊，掌心朝下。"
    },
    "ju-naname-uchi-3": {
      "text": "受握取的手腕，向左轉並將取向前拉。取左腳前進，以左手握住並推受的左手腕，解脫自己的手腕。"
    },
    "ju-naname-uchi-4": {
      "text": "受將手放在取的肘部，迫使取轉身。"
    },
    "ju-naname-uchi-5": {
      "text": "取轉身，以裏投（Ura-nage）舉起受，上身後仰。受雙腿併攏，雙臂伸直於頭上。"
    },
    "ju-katate-dori-1": {
      "text": "受握取的右手腕。"
    },
    "ju-katate-dori-2": {
      "text": "取右腳斜向前進，以伸直的手臂向上抬起，施以關節技（Kansetsu-waza）。"
    },
    "ju-katate-dori-3": {
      "text": "受右腳前進防守，以右掌推開取的右肘，鬆開左手，拉取的左肩。"
    },
    "ju-katate-dori-4": {
      "text": "取轉身，以浮腰（Uki-goshi）過渡至大腰（O-Goshi），將受舉起。"
    },
    "ju-katate-age-1": {
      "text": "取與受抬起右臂及腳跟後，互相接近。"
    },
    "ju-katate-age-2": {
      "text": "取右腳向旁踏出避免相撞，控制受的左肩及右肘；受作出反應，取控制受的左肘；受再次反應。取直立控制受的反應；動作與反應均緩慢，兩人距離非常接近。"
    },
    "ju-katate-age-3": {
      "text": "結束：取使受右臂伸直，向後失去平衡。"
    },
    "ju-obi-tori-1": {
      "text": "受左腳踏前，雙臂交叉、左手在上、雙掌朝下，嘗試握取的腰帶。"
    },
    "ju-obi-tori-2": {
      "text": "取以右手握受的左手腕，手背朝下，向自己的左方拉；再以左手控制受的左肘並向上推，隨後以右手拉受的右肩，嘗試將受的身體向右轉。"
    },
    "ju-obi-tori-3": {
      "text": "受旋轉，將取的右肘向側方拉，並拉取的左肩，同時將取的肘部向上推。"
    },
    "ju-obi-tori-4": {
      "text": "取再次轉身，將受拉近髖部，以浮腰再過渡至大腰舉起。"
    },
    "ju-mune-oshi-1": {
      "text": "受以右掌推取的左胸。取胸部後仰，以左手作矢筈（Yahazu，V 字形）將受的右手腕向上推，同時以右手推受的左胸。受握取的右手腕，雙方朝正面方向旋轉，過程中更換握法。錯誤類別：輕微／中等（Small/Medium）。"
    },
    "ju-mune-oshi-2": {
      "text": "取控制受的右臂，更換對受伸直左臂肘部的握法，使受向右後隅失去平衡。錯誤類別：輕微／中等（Small/Medium）。"
    },
    "ju-mune-oshi-3": {
      "text": "結束：取先踏入右腳、再踏入左腳，降低髖部，使受進一步失去平衡。錯誤類別：中等（Medium）。"
    },
    "ju-tsuki-age-1": {
      "text": "受右腳後退，再向前踏出，嘗試以上勾拳攻擊取的下巴。"
    },
    "ju-tsuki-age-2": {
      "text": "取後仰避開攻擊，以右手接住拳頭，左掌置於受的右肘，左腳前進並使受轉身。"
    },
    "ju-tsuki-age-3": {
      "text": "受以左腳為軸旋轉 360°。"
    },
    "ju-tsuki-age-4": {
      "text": "取將受的右臂直向上拉，以左手握受的右肘，以腕緘（Ude-garami）的形式繞住受的肩部，使受向右後隅失去平衡。取依左腳、右腳順序踏入。"
    },
    "ju-uchi-oroshi-1": {
      "text": "受以大圓動作抬起右拳及右臂，右腳前進，嘗試以右拳背擊取的頭頂。"
    },
    "ju-uchi-oroshi-2": {
      "text": "取依右腳、左腳順序後退，右手由上方以正常握法握受的右手腕，以繼足前進兩步，使受向右後隅失去平衡。"
    },
    "ju-uchi-oroshi-3": {
      "text": "受翻轉左手，指尖朝下，從前方將掌心置於取的右肘並推壓，使取的身體向左大幅轉動。"
    },
    "ju-uchi-oroshi-4": {
      "text": "取以左腳為軸轉身，左手由上方握受的左手腕，移至受的後方，使受向後失去平衡。"
    },
    "ju-uchi-oroshi-5": {
      "text": "結束：取使受向後失去平衡，同時以左手對受的左臂施關節技，以右手腕施絞技（Shime-waza）。"
    },
    "ju-ryogan-tsuki-1": {
      "text": "受抬起右手，手指伸直，無名指與中指分開，右腳前進，以突刺攻擊取的雙眼。"
    },
    "ju-ryogan-tsuki-2": {
      "text": "取向左轉，避開突刺，以左手握受的右手腕並拉其手臂。"
    },
    "ju-ryogan-tsuki-3": {
      "text": "受左腳前進，以左手握取的左手腕，解脫右臂。"
    },
    "ju-ryogan-tsuki-4": {
      "text": "取以右掌推受的左肘，解脫左臂。"
    },
    "ju-ryogan-tsuki-5": {
      "text": "受以右腳為軸轉身。"
    },
    "ju-ryogan-tsuki-6": {
      "text": "取左腳前進，以左手突刺受的雙眼，手指伸直，無名指與中指分開。"
    },
    "ju-ryogan-tsuki-7": {
      "text": "受向右轉，避開突刺，以右手握取的左手腕並拉其手臂。"
    },
    "ju-ryogan-tsuki-8": {
      "text": "取右腳前進，以右手握受的右手腕，解脫左臂。"
    },
    "ju-ryogan-tsuki-9": {
      "text": "受以左掌推取的右肘，解脫右臂並嘗試使取轉身；但取以手臂環抱受的腰部，以浮腰過渡至大腰舉起受。"
    }
  }
}
